import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

export default function AdminInbox() {
  const [messages, setMessages] = useState([]);
  const [subs, setSubs] = useState([]);

  useEffect(() => {
    api.get("/admin/messages").then((r) => setMessages(r.data));
    api.get("/admin/newsletter").then((r) => setSubs(r.data));
  }, []);

  const markRead = async (m) => { await api.patch(`/admin/messages/${m.id}/read?value=${!m.read}`); setMessages((prev) => prev.map((x) => x.id === m.id ? { ...x, read: !m.read } : x)); };

  return (
    <div>
      <h1 className="font-serif text-3xl text-kys-ink">Inbox</h1>
      <Tabs defaultValue="messages" className="mt-5">
        <TabsList>
          <TabsTrigger value="messages" data-testid="tab-messages">Messages ({messages.filter((m) => !m.read).length})</TabsTrigger>
          <TabsTrigger value="newsletter" data-testid="tab-newsletter">Newsletter ({subs.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="messages">
          <div className="mt-4 space-y-3">
            {messages.map((m) => (
              <div key={m.id} className={`rounded-lg border p-4 ${m.read ? "border-kys-blush-border bg-white" : "border-kys-accent bg-kys-blush"}`}>
                <div className="flex items-center justify-between">
                  <p className="font-medium text-kys-ink">{m.name} <span className="text-xs text-kys-muted">· {m.email}</span></p>
                  <button onClick={() => markRead(m)} className="text-xs text-kys-accent">{m.read ? "Mark unread" : "Mark read"}</button>
                </div>
                <p className="mt-2 text-sm text-kys-charcoal">{m.message}</p>
                <p className="mt-1 text-[11px] text-kys-muted">{new Date(m.created_at).toLocaleString()}</p>
              </div>
            ))}
            {messages.length === 0 && <p className="py-10 text-center text-sm text-kys-muted">No messages.</p>}
          </div>
        </TabsContent>
        <TabsContent value="newsletter">
          <div className="mt-4 rounded-lg border border-kys-blush-border bg-white">
            {subs.map((s) => (
              <div key={s.email} className="flex justify-between border-b border-kys-blush-border p-3 text-sm last:border-0">
                <span>{s.email}</span><span className="text-xs text-kys-muted">{new Date(s.created_at).toLocaleDateString()}</span>
              </div>
            ))}
            {subs.length === 0 && <p className="py-10 text-center text-sm text-kys-muted">No subscribers yet.</p>}
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
